var DocsAPI = /** @class */ (function () {
    function DocsAPI() {
    }
    DocsAPI.getInstance = function () {
        if (!this.instance) {
            this.instance = new DocsAPI();
        }
        return this.instance;
    };
    DocsAPI.prototype.registerDesktopApp = function (app) {
        this.DesktopApp = app;
    };
    DocsAPI.prototype.registerDocumentApp = function (app) {
        this.DocumentApp = app;
    };
    DocsAPI.prototype.registerSheetApp = function (app) {
        this.SheetApp = app;
    };
    DocsAPI.prototype.registerSlideApp = function (app) {
        this.SlideApp = app;
    };
    DocsAPI.prototype.registerFormApp = function (app) {
        this.FormApp = app;
    };
    DocsAPI.prototype.registerPDFApp = function (app) {
        this.PDFApp = app;
    };
    DocsAPI.prototype.registerSmartCanvasApp = function (app) {
        this.SmartCanvasApp = app;
    };
    DocsAPI.prototype.registerSmartSheetApp = function (app) {
        this.SmartSheetApp = app;
    };
    DocsAPI.prototype.registerMindApp = function (app) {
        this.MindApp = app;
    };
    DocsAPI.prototype.registerFlowChartApp = function (app) {
        this.FlowChartApp = app;
    };
    DocsAPI.prototype.registerResumeApp = function (app) {
        this.ResumeApp = app;
    };
    DocsAPI.prototype.registerDesktopFeature = function (feature) {
        this.DesktopFeature = feature;
    };
    DocsAPI.prototype.registerDocumentFeature = function (feature) {
        this.DocumentFeature = feature;
    };
    DocsAPI.prototype.registerSheetFeature = function (feature) {
        this.SheetFeature = feature;
    };
    DocsAPI.prototype.registerSlideFeature = function (feature) {
        this.SlideFeature = feature;
    };
    DocsAPI.prototype.registerFormFeature = function (feature) {
        this.FormFeature = feature;
    };
    DocsAPI.prototype.registerPDFFeature = function (feature) {
        this.PDFFeature = feature;
    };
    DocsAPI.prototype.registerSmartCanvasFeature = function (feature) {
        this.SmartCanvasFeature = feature;
    };
    DocsAPI.prototype.registerSmartSheetFeature = function (feature) {
        this.SmartSheetFeature = feature;
    };
    DocsAPI.prototype.registerMindFeature = function (feature) {
        this.MindFeature = feature;
    };
    DocsAPI.prototype.registerFlowChartFeature = function (feature) {
        this.FlowChartFeature = feature;
    };
    DocsAPI.prototype.registerResumeFeature = function (feature) {
        this.ResumeFeature = feature;
    };
    DocsAPI.prototype.registerFileKit = function (fileKit) {
        this.FileKit = fileKit;
    };
    return DocsAPI;
}());
export { DocsAPI };
//# sourceMappingURL=index.js.map